export const TechnologyConstants = {
    GENERAL_TECHNOLOGY_ID: -1,
    GENERAL_TECHNOLOGY_NAME: "General"
} as const;